/**
 * Multi-mode Branding System
 * Switches between INTERNAL (Analyst Copilot), PUBLIC (ReqRel), and DEMO (ReqRel Demo) modes
 */

import type { AppMode, Language, BrandingConfig } from '@/types/branding.types'

/**
 * Get branding configuration based on environment variable
 */
export function getBrandingConfig(): BrandingConfig {
  const appMode = (import.meta.env.VITE_APP_MODE as AppMode | undefined) ?? 'INTERNAL'

  if (appMode === 'DEMO') {
    return {
      appMode: 'DEMO',
      appName: 'ReqRel',
      appIcon: '🚀',
      language: 'en',
      logoPath: '/appicons/reqrel_logo.png',
      isDemo: true,
      supportEmail: 'contact@reqrel.com',
    }
  }

  if (appMode === 'PUBLIC') {
    return {
      appMode: 'PUBLIC',
      appName: 'ReqRel',
      appIcon: '🚀',
      language: 'en',
      logoPath: '/appicons/reqrel_logo.png',
      isDemo: false,
      supportEmail: 'support@reqrel.com',
    }
  }

  // INTERNAL mode (default)
  return {
    appMode: 'INTERNAL',
    appName: 'Analyst Copilot',
    appIcon: '🤖',
    language: 'ru',
    logoPath: '/appicons/analyst_copilot_logo.png',
    isDemo: false,
    supportEmail: 'support@analyst-copilot.ru',
  }
}

/**
 * Global branding configuration instance
 * Computed once at app initialization
 */
export const branding = getBrandingConfig()

/**
 * Check if app is in INTERNAL mode
 */
export const isInternalMode = branding.appMode === 'INTERNAL'

/**
 * Check if app is in PUBLIC mode
 */
export const isPublicMode = branding.appMode === 'PUBLIC'

/**
 * Check if app is in DEMO mode
 */
export const isDemoMode = branding.isDemo

/**
 * Get current language
 */
export const currentLanguage: Language = branding.language
